{

    const languageSwitcherOnMenubar = document.querySelector('.js-menubar-nav__language');

    // Language Tongue
    languageSwitcherOnMenubar && languageSwitcherOnMenubar.addEventListener('click', () => {
        const languageSwitcher = document.querySelector('.js-menubar-nav__language #header-language');
        languageSwitcher && languageSwitcher.classList.toggle('header-language_active');
    });

    const headerLanguages = document.querySelectorAll('#header-language');

    headerLanguages.forEach(headerLanguage => {
        headerLanguage.addEventListener('click', (e) => {
            e.preventDefault();
            let link = e.target.closest('.header-language__link');

            if (!link ) return;
            if (!link.hasAttribute('data-lang')) return;

            const domain = !document.location.host.includes('localhost')
                ? `;domain=${document.location.host.replace(/^www.|/, '.')}`
                : '';

            document.cookie = `lang_id=${link.getAttribute('data-lang')}` + domain + ';path=/';
            window.location.reload();
        });
    });


    /**
     * https://protonixltd.atlassian.net/browse/TL-19495
     * Update custom languages cookie without suffix
     * */

    const langId = m.cookie.get('lang_id');
    const customLanguages = ['es-419', 'pt-pt', 'pt-br'];

    if (!!langId && customLanguages.includes(langId)) {
        m.cookie.set('lang_id', langId.split('-')[0]);
    }
}
